import { MediaModel } from 'src/app/story/models/media.model';
import { SceneIO } from '../models/scene.io';

// convert the old capture format to the new capture format
export namespace SceneAPIUtils {
  export function isLegacyCaptureFormat(
    capture: SceneIO.SceneCapture | SceneIO.LegacySceneCapture,
  ): capture is SceneIO.LegacySceneCapture {
    return (capture as SceneIO.LegacySceneCapture).engineVersion !== undefined;
  }

  export function convertCaptureFormat(capture: SceneIO.LegacySceneCapture): SceneIO.SceneCapture {
    const objects = Object.keys(capture.objects).reduce<SceneIO.ObjectCaptureInfo[]>(
      (acc, objectId) => {
        acc.push({
          objectId,
          selected: false,
          hidden: false,
        });
        return acc;
      },
      [],
    );

    return {
      storyId: capture.timeline.rootName.replace('.json', ''),
      camera: {
        lookAt: capture.camera,
        zoom: undefined,
      },
      labels: [], // No support
      objects, // old capture data does not include selected information.
      background: [], // No support
      activeChapterId: capture.timeline.scrub ? capture.timeline.scrub.chapterId : undefined,
    };
  }

  export function convertMediaFormat(
    media: Record<string, MediaModel>,
  ): Record<string, SceneIO.SceneMediaModel> {
    const convertedMedia = {};

    Object.entries(media).forEach(([key, value]) => {
      convertedMedia[key] = {
        fullUrl: value.data.fullUrl,
        lang: value.data.lang,
        streamType: value.data.streamType,
      };
    });

    return convertedMedia;
  }
}
